<h2 mat-dialog-title>{{ data.component ?? ('component' | translate) }}</h2>
<mat-dialog-content class="measurement-input">
	<mat-form-field>
		<mat-label>{{ 'enter_new_value' | translate }}</mat-label>
		<input type="number" matInput [(ngModel)]="value" (keyup.enter)="submit()" />
		<span matTextSuffix> {{ data.unit }}</span>
	</mat-form-field>
	<cmms-date-picker
		[isInputBased]="true"
		[disableFutureDates]="true"
		label="{{ 'date' | translate }}"
		[value]="date()"
		(dateChanged)="date.set($event)"
	/>
	<div class="time">
		<mat-form-field>
			<mat-label>{{ 'hour' | translate }}</mat-label>
			<input type="number" min="0" max="23" matInput [(ngModel)]="hour" />
		</mat-form-field>
		:
		<mat-form-field>
			<mat-label>{{ 'minute' | translate }}</mat-label>
			<input type="number" min="0" max="59" matInput [(ngModel)]="minute" />
		</mat-form-field>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="align-end">
	<button
		mat-button
		(click)="cancel()"
		class="au-mat-flat-stroke au-mat-btn-xs uppercase"
	>
		{{ 'cancel' | translate }}
	</button>
	<button
		mat-button
		(click)="submit()"
		class="au-mat-flat-stroke au-mat-btn-xs save-button uppercase"
		matRipple
	>
		{{ 'submit' | translate }}
	</button>
</mat-dialog-actions>
